export { default } from './game.component';
